var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({'background': 'url(' + require('@/assets/img/background-dates.png') + ') no-repeat center center fixed'}),attrs:{"id":"dates"}},[_c('Dates')],1)}
var staticRenderFns = []

export { render, staticRenderFns }